import axiosFactory, { METHOD_GET } from "./AxiosFactory";
import { CURRENT_USER } from "./UrlConstants";

// The site keeps a copy of the signed-in user in localStorage("user"), taken
// at login. It was never updated afterwards, so a lawyer approved by an
// operator kept seeing "under review" until they logged out and in again.
// refreshCurrentUser() replaces that copy with the server's current one.

export const USER_UPDATED_EVENT = "avc-user-updated";

export function storedUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch (e) {
    return null;
  }
}

export function isApprovedLawyer(user) {
  return Boolean(user && user.role === "lawyer" && user.lawyerID && user.lawyerID.verified);
}

// Resolves to the fresh user, or null when signed out or unreachable (the
// stored copy is then left as it was).
export async function refreshCurrentUser() {
  if (!storedUser() || !localStorage.getItem("jwtAccessToken")) return null;
  const response = await axiosFactory({ url: CURRENT_USER, method: METHOD_GET });
  const fresh = response.status === 200 && response.data && response.data.data;
  // On a network failure AxiosFactory puts a message string in `data`.
  if (!fresh || typeof fresh !== "object" || !fresh._id) return null;
  localStorage.setItem("user", JSON.stringify(fresh));
  window.dispatchEvent(new Event(USER_UPDATED_EVENT));
  return fresh;
}
